/**
 * Converts the backend keyDates array [{keyDateType, keyDate}] into a
 * camelCase object { clearedToCloseDate: "2026-02-20T00:00:00", ... }
 * that KeyDatesCard and LoanVelocityTiles expect.
 *
 * Backend keyDateType values are PascalCase (e.g. "ClearedToCloseDate").
 * The UI components expect camelCase (e.g. "clearedToCloseDate").
 */

const toCamelCase = (str) => {
  if (!str) return str;
  return str.charAt(0).toLowerCase() + str.slice(1);
};

export const keyDatesArrayToObject = (keyDatesArray) => {
  if (!keyDatesArray || !Array.isArray(keyDatesArray)) return {};
  const obj = {};
  for (const entry of keyDatesArray) {
    if (entry.keyDateType && entry.keyDate) {
      obj[toCamelCase(entry.keyDateType)] = entry.keyDate;
    }
  }
  return obj;
};
